import { Radio, Stack } from "@mui/material";
import React from "react";

const EditableStandaloneRadio = ({
  RadioValue,
  compareField,
  setUi,
  placeholder,
  onChange,
  UiItem,
}) => {
  React.useEffect(() => {
    if (UiItem.value === 1) {
      setUi(UiItem?.element?.ElsRecord?.Id);
    }
  }, []);
  React.useEffect(() => {
    if (parseInt(RadioValue) === compareField) {
      onChange && onChange(1);
    } else {
      onChange && onChange("");
    }
  }, [RadioValue]);
  return (
    <React.Fragment>
      <Stack direction="row" alignItems="center">
        <Radio
          color="colorPrimer"
          sx={{ pr: 0 }}
          checked={parseInt(RadioValue) === compareField}
          onChange={(event) => {
            setUi(event.target.value);
          }}
          value={compareField}
          name="radio-buttons"
          inputProps={{
            "aria-label": `${placeholder}`,
          }}
        />
        <p>{placeholder}</p>
      </Stack>
    </React.Fragment>
  );
};

export default EditableStandaloneRadio;
